/* Factory Store
   Fuerza el layout mobile del header nativo debajo de 990px.

   Horizon decide el layout del header con el atributo data-menu-style:
     'menu'   -> grilla de escritorio (logo / menu / acciones)
     'drawer' -> grilla mobile (hamburguesa, logo centrado, acciones)

   El script inline de layout/theme.liquid lo resuelve mirando si el
   dispositivo es tactil, NO el ancho de la ventana. En un notebook
   achicado a 850px daba 'menu', y el header se veia con layout de
   escritorio en un ancho donde ya deberia verse como mobile.

   Aca lo atamos al mismo breakpoint de 990px que usan
   assets/factory-mobile.css y snippets/factory-mega-menu.liquid. */
(function () {
  var BREAKPOINT = 990;

  function resolve(header) {
    if (window.innerWidth < BREAKPOINT) return 'drawer';

    // Arriba de 990 respetamos la logica original del tema.
    var isTouchDevice = 'ontouchstart' in window && navigator.maxTouchPoints > 0;
    var overflowList = header.querySelector('overflow-list');
    var hasReachedMinimum = overflowList && overflowList.hasAttribute('minimum-reached');
    return isTouchDevice || hasReachedMinimum ? 'drawer' : 'menu';
  }

  function apply() {
    var header = document.querySelector('#header-component');
    if (!header) return;

    var next = resolve(header);
    if (header.dataset.menuStyle !== next) {
      header.dataset.menuStyle = next;
    }
  }

  var frame = null;
  function onResize() {
    if (frame) cancelAnimationFrame(frame);
    frame = requestAnimationFrame(apply);
  }

  apply();
  window.addEventListener('resize', onResize, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  }
})();
